<label class="epcTitle">EPC Values</label>
<div class="epcBox">
  <div class="epcValues">
    <label>{{ epcPlatform }}</label>
    <label class="epcLabels">PLATFORM</label>
  </div>
  <div class="epcValues">
    <label>{{ epcEstimate }}</label>
    <label class="epcLabels">ESTIMATE</label>
  </div>
  <div class="epcValues">
    <label>{{ epcActual }}</label>
    <label class="epcLabels">ACTUAL</label>
  </div>
</div>
